import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { EntityManager } from "@/components/EntityManager";
import { ENTITY_CONFIG } from "@/lib/entities";

export default function Investments() {
  return (
    <div className="space-y-6">
      <Tabs defaultValue="investments">
        <TabsList data-testid="investments-tabs">
          <TabsTrigger value="investments" data-testid="tab-fixed-investments">
            Fixed Investments
          </TabsTrigger>
          <TabsTrigger value="firc" data-testid="tab-firc">
            FIRCs vs Invoices
          </TabsTrigger>
        </TabsList>
        <TabsContent value="investments" className="mt-6">
          <EntityManager config={ENTITY_CONFIG.investments} />
        </TabsContent>
        <TabsContent value="firc" className="mt-6">
          <EntityManager config={ENTITY_CONFIG.firc} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
